import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeProgress(_id:$_id){
        recordId
      }
}
`